import Icon from '../../components/Icon';
import Botao from '../../components/Botao';
import styles from './AlertasAtendimento.module.css';
import { mdiHeadset, mdiVolumeHigh } from '@mdi/js';
import React, { useCallback } from 'react';
import TextoData from '@/components/tipografia/TextoData';
import VBox from '@/components/layout/VBox';
import HBox from '@/components/layout/HBox';
import { useUserInteracted } from '@/hooks/useUserInteracted';

type AlertaAtendimentoDto = {};

type AlertasAtendimentoProps = {
  value: any[];
  isPlayingAudio: boolean;
  onAtender: (chatId: number) => void;
  hasFilaChamadas: boolean;
};
const AlertasAtendimento = ({
  value,
  isPlayingAudio,
  onAtender,
  hasFilaChamadas
}: AlertasAtendimentoProps) => {

  const userInteracted = useUserInteracted();

  const handleFilaAtenderClick = useCallback(
    (chatId: number) => {
      console.log('handleFilaAtenderClick', chatId);
      onAtender(chatId);
    },
    [onAtender],
  );

  const loopHandler = React.useRef<any>(null);
  const audioAtendimentoRef = React.useRef<HTMLAudioElement>(
    typeof window !== 'undefined' ? new Audio('/sounds/atendimento.mp3') : null,
  );

  const [chatsSendingRequest, setChatsSendingRequest] = React.useState<number[]>([]);

  React.useEffect(() => {
    if (!value?.length) {
      setChatsSendingRequest([]);
      return;
    }

    setChatsSendingRequest(prev => prev.filter(id => value.some(item => item.id === id)));
  }, [value])

  React.useEffect(() => {
    if (!audioAtendimentoRef.current || !userInteracted || hasFilaChamadas) {
      if (!audioAtendimentoRef.current || audioAtendimentoRef.current.paused) return;

      clearInterval(loopHandler.current);
      audioAtendimentoRef.current.pause();
      audioAtendimentoRef.current.currentTime = 0;
      loopHandler.current = null;
      return;
    }

    if (value?.length > 0) {
      if (!loopHandler.current) {
        audioAtendimentoRef.current.play().catch((err) => {
          console.warn('Erro ao tocar som de atendimento automático.', { err });
        });

        loopHandler.current = setInterval(() => {
          if (!audioAtendimentoRef.current) return;

          audioAtendimentoRef.current.play().catch((err) => {
            console.warn('Erro ao tocar som de atendimento automático.', { err });
          });
        }, 15000);
      }
    } else {
      if (loopHandler.current) {
        clearInterval(loopHandler.current);
        audioAtendimentoRef.current.pause();
        audioAtendimentoRef.current.currentTime = 0;
        loopHandler.current = null;
      }
    }
  }, [value?.length, userInteracted]);

  React.useEffect(() => {
    if ((!audioAtendimentoRef.current || !userInteracted)) {
      return
    }

    if (isPlayingAudio) {
      audioAtendimentoRef.current.volume = 0.05;
    } else {
      audioAtendimentoRef.current.volume = 1;
    }
  }, [isPlayingAudio])

  return (
    <div style={{ margin: '8px 0' }}>
      {value?.map((item, index) => (
        <div
          key={`alerta-atendimento-${index}`}
          className={styles.container}
          title="Este aviso está gerando o som"
        >
          <div className={styles.alerta}>
            <HBox stretch>
              <VBox>
                <span>Novo atendimento</span>
                <div
                  style={{
                    fontWeight: 400,
                    fontStyle: 'italic',
                    fontSize: '12px',
                  }}
                >
                  Entr: <TextoData value={item.fila_data_criacao} />
                </div>
              </VBox>
              <Botao
                variant="primary"
                icon={mdiHeadset}
                onClick={() => handleFilaAtenderClick(item.id)}
                disabled={chatsSendingRequest.includes(item.id)}
              >
                {chatsSendingRequest.includes(item.id) ? 'Aguarde...' : 'Atender'}
              </Botao>
              <Icon
                path={mdiVolumeHigh}
                size={2.5}
                color="var(--tc-color-gray-500)"
              />
            </HBox>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertasAtendimento;
